import { render, staticRenderFns } from "./NoticeBoxItem.vue?vue&type=template&id=01cf8b2a&scoped=true&"
import script from "./NoticeBoxItem.vue?vue&type=script&lang=js&"
export * from "./NoticeBoxItem.vue?vue&type=script&lang=js&"
import style0 from "./NoticeBoxItem.vue?vue&type=style&index=0&id=01cf8b2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cf8b2a",
  null
  
)

export default component.exports